import { useMemo } from 'react'
import { filtersConfig } from '~/features/BookingCars/ListBookingCars/config'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { FiltersActiveIcon, FiltersIcon } from '~/shared/ui/icons'
import {
  sanitizeFilterFields,
  useFiltersQueryParams,
} from '~/shared/ui/ScrollableList'
import { myPalette } from '~/shared/ui/theme'
import { Content } from './Content'

export function Filters() {
  const [isShow, openDrawer, closeDrawer] = useDrawer()

  const [filtersQuery] = useFiltersQueryParams(filtersConfig)

  const isFiltersSelected = useMemo(() => {
    const fields = sanitizeFilterFields(filtersConfig)
    return fields.some((field) => !!filtersQuery[field])
  }, [filtersQuery])

  return (
    <div>
      <Button
        startDecorator={
          <div style={{ marginRight: '6px' }}>
            {isFiltersSelected ? <FiltersActiveIcon /> : <FiltersIcon />}
          </div>
        }
        variant='textLink'
        onClick={openDrawer}
        contentProps={{ style: { padding: '0' } }}
        style={{ color: myPalette.black.main, fontSize: '14px' }}
      >
        Фильтры
      </Button>

      <DrawerComponent isShow={isShow} onCancel={closeDrawer}>
        <Content onClose={closeDrawer} />
      </DrawerComponent>
    </div>
  )
}
